export class ChangePasswordModel {
  confirmPassword: string;
  newPassword: string;
  oldPassword: string;
}

export class CurrentUser {
  username: string;
  role: string;
  corporationid?: number;
  email: string;
  authenticated: boolean;
  pages: Page[];
}

export class Page {
  displayName: string;
  route: string;
  modelName:string;
  permission: string;
  iconName: string;
  order:number;
}

export interface PasswordRecoveryModel {
  answer: string;
  passwordSecurityQuestionId: number;
  question: string;
  setId: number;
}

export class PasswordSecurity {
  answerList: PasswordSecurityAnswer[];
  password: string;
}

export class PasswordSecurityAnswer {
  answer: string;
  passwordSecurityQuestionId: number;
  setId: number;
}

export class ResetPasswordSecurityModel {
  confirmPassword: string;
  password: string;
  token: string;
  userId: Number;
}

export enum PasswordSecurityErrorMessage{
  CURRENT_PASSWORD_REQUIRED = 'Current password required',
  QUESTION_REQUIRED = 'Question selection required',
  ANSWER_REQUIRED = 'Answer Required',
  ANSWER_LENGTH_ATLEAST = 'Answer length must be at least ',
  ANSWER_NOT_SAME_AS_OTHER_ANSWER = 'Answer can not be the same as any other answer',
  FOLLOWING_ERRORS_FOUND = 'The following errors were found:',
  CHANGES_TO_QUESTIONS_SAVED = 'The changes to the security questions are saved.',
}
